// Deduplicates concurrent identical GET requests at the jQuery level.
// When a GET to a URL is already in-flight, subsequent calls piggyback on the
// existing request rather than sending duplicates to the server. This prevents
// N×instance bursts from directives like iio-combo-box that each fire the same
// autocomplete endpoint on init.

const CACHE_TTL_MS = 2 * 60 * 1000;

(function patchAjax($: JQueryStatic) {
  const inFlight = new Map<string, JQuery.jqXHR<any>>();
  const cache = new Map<string, { data: any; status: string; xhr: any; expires: number }>();
  const orig = ($ as any).ajax.bind($) as typeof $.ajax;

  ($ as any).ajax = function(urlOrSettings: any, settings?: any): any {
    const opts: any = typeof urlOrSettings === 'string'
      ? { url: urlOrSettings, ...settings }
      : { ...urlOrSettings };

    if ((opts.type || opts.method || 'GET').toUpperCase() !== 'GET' || !opts.url) {
      return orig(opts);
    }

    const url: string = opts.url;

    // Serve from cache if still fresh.
    const cached = cache.get(url);
    if (cached && cached.expires > Date.now()) {
      const deferred = $.Deferred<any>();
      opts.success?.(cached.data, cached.status, cached.xhr);
      deferred.resolve(cached.data, cached.status, cached.xhr);
      return Object.assign(deferred.promise(), { abort: () => {} });
    }

    // Piggyback on an identical in-flight request.
    if (inFlight.has(url)) {
      const deferred = $.Deferred<any>();
      inFlight.get(url)!
        .done((data: any, status: string, xhr: any) => {
          opts.success?.(data, status, xhr);
          deferred.resolve(data, status, xhr);
        })
        .fail((xhr: any, status: string, error: string) => {
          opts.error?.(xhr, status, error);
          deferred.reject(xhr, status, error);
        });
      return Object.assign(deferred.promise(), { abort: () => {} });
    }

    const req = orig(opts);
    inFlight.set(url, req);
    req
      .done((data: any, status: string, xhr: any) => {
        cache.set(url, { data, status, xhr, expires: Date.now() + CACHE_TTL_MS });
      })
      .always(() => inFlight.delete(url));
    return req;
  };
}($));
